// Copy and change detection for the confirmation shown before an affiliate's contact groups are
// saved. specs/affiliate-group-change-confirm (plan arch 5).

export const GROUP_CHANGE_TITLE = 'Change contact groups?'

const UNNAMED_GROUP = 'an unnamed group'

const idSet = (ids) => new Set((Array.isArray(ids) ? ids : []).map(String).filter(Boolean))

// Order and repeats are not a change: the form may resubmit the same membership in any order.
export const groupsChanged = (initialIds, currentIds) => {
  const before = idSet(initialIds)
  const after = idSet(currentIds)
  return before.size !== after.size || [...after].some((id) => !before.has(id))
}

const counted = (count, noun) => `${count} ${noun}${count === 1 ? '' : 's'}`

const nameOf = (group) => group?.name || UNNAMED_GROUP

const movesMessage = ({ name, moves }) => {
  const to = nameOf(moves.to)
  if (!moves.total) return `${name} will move to ${to}. They have no files to move.`

  const from = (moves.from || []).map(nameOf).join(', ')
  const split = `${counted(moves.leads, 'lead')}, ${counted(moves.clients, 'client')}`
  return `${counted(moves.total, 'file')} (${split}) will move with ${name} from ${from} to ${to}.`
}

const hiddenMessage = ({ office, total, leads, clients }) =>
  ` ${office?.name || 'An office'} will stop seeing ${counted(total, 'file')} (${counted(leads, 'lead')}, ${counted(clients, 'client')}), owners included.`

const stayingMessage = ({ name, groupCount, hidden }) => {
  const groupsText = groupCount ? counted(groupCount, 'group') : 'no group'
  if (!Array.isArray(hidden) || hidden.length === 0) return `Files stay where they are: ${name} will be in ${groupsText}.`
  return `${name} will be in ${groupsText}.${hidden.map(hiddenMessage).join('')} Staff still see them.`
}

export const groupChangeMessage = ({ name, preview, failed = false }) => {
  if (failed || !preview) return `Couldn't check how many files will move. Saving may move ${name}'s files.`
  if (preview.moves) return movesMessage({ name, moves: preview.moves })
  return stayingMessage({ name, groupCount: preview.groupCount, hidden: preview.hidden })
}
